import { Component, OnInit } from '@angular/core';
import {PublicService} from '../public.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit {

  constructor(public publicservice : PublicService, public router: Router ) { }

  ngOnInit(): void {
  }


  profileClick() {
    console.log('fsff');
    this.router.navigate(['get-location']);
}
}
